/**
 * @generated SignedSource<<f7ba598fab94e932f31527824e7866a2>>
 * @relayHash c76a0108f60c565783452e6658a3cf18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookUsageQuery } from './PlaybookUsageQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookUsageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1ec0a456168b3b9b4a9c87ab77c8fe13240bb085fd5d2df1530d3abc4c6d359f",
    "metadata": {},
    "name": "PlaybookUsageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
